/**
 * Status kept in the free-text `progress` field of a webinar. The real progress is
 * stored per video, this field only tells whether the user has started the webinar.
 */
export enum WebinarProgressStatus {
  IN_PROGRESS = 'in_progress',
}
